import Icon from '../../components/Icon.vue'

Icon.register({"brands/cloudsmith":{"width":332,"height":512,"paths":[{"d":"M332.5 419.9C332.5 466.3 294.9 504 248.5 504S164.5 466.3 164.5 419.9 202.1 335.9 248.5 335.9 332.5 373.5 332.5 419.9zM248.5 176C294.9 176 328.5 138.4 328.5 92S294.9 8 248.5 8 160.5 45.6 160.5 92 130.9 168 84.5 168 0.5 209.6 0.5 256 38.1 336 84.5 336 168.5 302.4 168.5 256 202.1 176 248.5 176z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/cloudsmith.js
// module id = Uwfw
// module chunks = 0